export default "__VITE_PUBLIC_ASSET__cfbd4a78__"